'use es6';

export var PRODUCT_CRM = 60;
export var PRODUCT_MARKETING_FREE = 114;
export var PRODUCT_MARKETING_STARTER = 108;
export var PRODUCT_MARKETING_STARTER_EMAIL = 250;
export var PRODUCT_MARKETING_STARTER_CONTACTS = 251;
export var PRODUCT_MARKETING_STARTER_NOV_2019 = 339;
export var PRODUCT_MARKETING_STARTER_CONTACTS_NOV_2019 = 340;
export var PRODUCT_MARKETING_STARTER_MC = 380;
export var PRODUCT_MARKETING_STARTER_CONTACTS_MC = 381;
export var PRODUCT_MARKETING_BASIC = 182;
export var PRODUCT_MARKETING_BASIC_CONTACTS = 191;
export var PRODUCT_MARKETING_PROFESSIONAL = 183;
export var PRODUCT_MARKETING_PROFESSIONAL_CONTACTS = 192;
export var PRODUCT_MARKETING_PROFESSIONAL_MC = 387;
export var PRODUCT_MARKETING_PROFESSIONAL_CONTACTS_MC = 388;
export var PRODUCT_MARKETING_ENTERPRISE = 184;
export var PRODUCT_MARKETING_ENTERPRISE_CONTACTS = 193;
export var PRODUCT_MARKETING_ENTERPRISE_MC = 389;
export var PRODUCT_MARKETING_ENTERPRISE_CONTACTS_MC = 390;
export var PRODUCT_SALES_FREE = 115;
export var PRODUCT_SALES_PRO_LEGACY = 1; // This product is no longer active and is the legacy legacy sales pro

export var PRODUCT_SALES_PRO_BUSINESS_USER = 4;
export var PRODUCT_SALES_STARTER = 186;
export var PRODUCT_SALES_STARTER_MAR_2020 = 359;
export var PRODUCT_SALES_STARTER_ADDL_USER_MAR_2020 = 360;
export var PRODUCT_SALES_PROFESSIONAL = 198;
export var PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER = 200;
export var PRODUCT_SALES_PROFESSIONAL_NOV_2019 = 337;
export var PRODUCT_SALES_PROFESSIONAL_ADDITIONAL_USER_NOV_2019 = 338;
export var PRODUCT_SALES_ENTERPRISE = 282;
export var PRODUCT_SALES_ENTERPRISE_ADDITIONAL_USER = 283;
export var PRODUCT_SERVICE_FREE = 296;
export var PRODUCT_SERVICE_STARTER = 261;
export var PRODUCT_SERVICE_STARTER_MAR_2020 = 362;
export var PRODUCT_SERVICE_STARTER_ADDL_USER_MAR_2020 = 363;
export var PRODUCT_SERVICE_PROFESSIONAL = 262;
export var PRODUCT_SERVICE_PROFESSIONAL_ADDITIONAL_USER = 263;
export var PRODUCT_SERVICE_ENTERPRISE = 285;
export var PRODUCT_SERVICE_ENTERPRISE_ADDITIONAL_USER = 286;
export var PRODUCT_CMS_PROFESSIONAL = 383;
export var PRODUCT_CMS_ENTERPRISE = 378;
export var ADDON_API = 113; // Deprecated as of 9/23/20, use LIMIT_INCREASE_API instead

export var ADDON_ADS = 9; // Deprecated

export var ADDON_ADS_CAPACITY = 300; // Deprecated as of 9/23/20, use LIMIT_INCREASE_ADS instead

export var ADDON_MARKETING_BASIC_WITH_PROFEESSIONAL_LIMITS = 38;
export var ADDON_DEDICATED_IP = 33;
export var ADDON_REPORTING = 406; // Deprecated as of 9/23/20, use LIMIT_INCREASE_REPORTING instead

export var ADDON_TRANSACTIONAL_EMAIL = 41;
export var ADDON_CUSTOM_SSL = 52; // TODO: Figure out merchandiseId
// export const ADDON_CUSTOM_SSL_THIRD_PARTY = null;

export var ADDON_WEBSITE_STARTER = 54;
export var ADDON_WEBSITE_UNLIMITED = 10; // TODO: Figure out merchandiseId
// export const ADDON_ADDITIONAL_PORTAL = null;

export var ADDON_BRAND_DOMAIN = 297;
export var ADDON_WORKFLOWS = 376;
export var ADDON_LISTS = 377;
export var LIMIT_INCREASE_REPORTING = 415;
export var LIMIT_INCREASE_ADS = 300;
export var LIMIT_INCREASE_API = 113;
export var LIMIT_INCREASE_ESIGNATURES = 416;
export var SERVICE_FIRST_TEMPLATE_SETUP = 18;
export var SERVICE_TEMPLATE_SETUP = 384;
export var SERVICE_TRAINING_MARKETING_FUNDAMENTALS = 268;
export var SERVICE_TRAINING_SALES_MARKETING_ALIGNMENT = 269;
export var SERVICE_TRAINING_CRM_MANAGEMENT = 270;
export var SERVICE_TRAINING_AGENCY_ACCOUNT_MANAGEMENT = 267;
export var SERVICE_INBOUND_CONSULTING_ONE_DAY = 36;
export var SERVICE_INBOUND_CONSULTING_FOUR_HOUR = 37;
export var SERVICE_DESIGNATED_TECHNICAL_SUPPORT = 39;
export var SERVICE_TECH_CONSULTING_ONE_DAY = 245;
export var SERVICE_TECH_CONSULTING_FOUR_HOURS = 275;
export var SERVICE_CONSULTING_AGENCY_PIPELINE = 175;
export var SERVICE_CONSULTING_SALES_SKILLS = 176;
export var SERVICE_MARKETING_BASIC_ONBOARDING = 42;
export var SERVICE_MARKETING_PROFESSIONAL_ONBOARDING = 45;
export var SERVICE_MARKETING_ENTERPRISE_ONBOARDING = 44;
export var SERVICE_CRM_SALES_STARTER_KIT = 57;
export var SERVICE_SALES_PROFESSIONAL_ONBOARDING = 254;
export var SERVICE_SALES_ENTERPRISE_ONBOARDING = 288;
export var SERVICE_SERVICE_PROFESSIONAL_ONBOARDING = 264;
export var SERVICE_SERVICE_ENTERPRISE_ONBOARDING = 289;
export var SERVICE_ENTERPRISE_SUITE_ONBOARDING = 290;
export var SERVICE_PROFESSIONAL_SUITE_ONBOARDING = 291;
export var SERVICE_CONTENT_PROFESSIONAL_ONBOARDING = 292;
export var SERVICE_HUBSPOT_FOR_STARTUPS_ONBOARDING = 260;
export var SERVICE_TECHNICAL_CONSULTING_ONGOING = 246;
export var SERVICE_INBOUND_CONSULTING_MONTHLY = 247;
export var SERVICE_INBOUND_CONSULTING_ONGOING = 248;
export var SERVICE_PREMIUM_CONSULTING = 249;
export var SERVICE_FIRST_TIME_FULL_MIGRATION = 272;
export var SERVICE_LATAM_MARKETING_PROFESSIONAL_ONBOARDING = 322;
export var SERVICE_LATAM_MARKETING_ENTERPRISE_ONBOARDING = 321;
export var SERVICE_SALES_PROFESSIONAL_ONBOARDING_NOV_2019 = 335;
export var SERVICE_SERVICE_PROFESSIONAL_ONBOARDING_NOV_2019 = 336;
export var SERVICE_MARKETING_STARTER_ONBOARDING = 332;
export var SERVICE_SALES_STARTER_ONBOARDING = 333;
export var SERVICE_SERVICE_STARTER_ONBOARDING = 334;
export var SERVICE_CMS_PROFESSIONAL_ONBOARDING = 292;
export var SERVICE_CMS_ENTERPRISE_ONBOARDING = 379;